/** @jsx jsx */
import PropTypes from 'prop-types';
import { jsx } from '@emotion/core';
import { withNamespaces } from 'react-i18next';
import { formatPriceToCurrencyString } from '../../../ui/PriceGenerator';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as dicts from '../../../../utils/dictionarykeys';
import * as styles from './index.styles.js';

const defaultData = {
  currency: '',
  total: '',
};

class FeaturesAndPricingPanelFooter extends SafePureComponent {
  generateShortCurrencyDict = priceUnit => `${priceUnit}_SHORT`;

  safeRender() {
    const { currency, t, total } = this.props;

    return (
      <div css={styles.totalWrapper}>
        <p css={styles.total}>
          {t(currency)} {formatPriceToCurrencyString(total)}
          <span css={styles.totalMessage}>
            {' '}
            /{t(dicts.SOLUTION_BUILDER.MONTHTEXT)}
          </span>
        </p>
        <p css={styles.discount}>{t(dicts.SOLUTION_BUILDER.DISCOUNT_TEXT)}</p>
      </div>
    );
  }
}

FeaturesAndPricingPanelFooter.displayName = 'SolutionBuilderResults/FeaturesAndPricingPanelFooter';

FeaturesAndPricingPanelFooter.defaultProps = {
  ...defaultData,
  t: key => key,
};

FeaturesAndPricingPanelFooter.propTypes = {
  currency: PropTypes.string,
  t: PropTypes.func,
  total: PropTypes.string,
};

export default withNamespaces()(FeaturesAndPricingPanelFooter);
